import React, { memo, useContext } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { ContractorsTableContext } from '../contractors-table/ContractorsTable.context'
import { TableSelect } from 'src/components/shared/table/TableSelect'
import { GSIcon } from 'src/components/shared/GSIcon'
import { RecollectionFilterValue } from 'src/interfaces/contractor'
import { colors } from 'src/theme'

const recollectionOptions = [
  {
    value: RecollectionFilterValue.Manual,
    component: (
      <div css={tw`flex items-center -ml-2`} style={{ gap: '10px' }}>
        <Typography variant="subtitle2" css={tw`font-bold w-4 text-center`}>
          M
        </Typography>
        <Typography variant="subtitle1" css={tw`font-normal`} color={colors.SHADES_GREY_400}>
          Manual
        </Typography>
      </div>
    ),
  },
  {
    value: RecollectionFilterValue.Automatic,
    component: (
      <div css={tw`flex items-center -ml-2`} style={{ gap: '10px' }}>
        <Typography variant="subtitle2" css={tw`font-bold w-4 text-center`}>
          A
        </Typography>
        <Typography variant="subtitle1" css={tw`font-normal`} color={colors.SHADES_GREY_400}>
          Auto
        </Typography>
      </div>
    ),
  },
  {
    value: RecollectionFilterValue.Without,
    component: (
      <Typography variant="subtitle1" css={tw`-ml-2 font-normal`} color={colors.SHADES_GREY_400}>
        Without recollection
      </Typography>
    ),
  },
]

const ContractorRecollectionSelectComponent = () => {
  const { recollectionFilter, setRecollectionFilter } = useContext(ContractorsTableContext)

  return (
    <TableSelect<RecollectionFilterValue>
      title="Recollection"
      icon={
        <GSIcon
          iconName="gs_arrows_repeat_right_left"
          width={20}
          height={20}
          css={tw`text-black`}
        />
      }
      options={recollectionOptions}
      selectedValues={recollectionFilter}
      onSelect={setRecollectionFilter}
    />
  )
}

export const ContractorRecollectionSelect = memo(ContractorRecollectionSelectComponent)
